import { HostListener, Injectable } from '@angular/core'; 

@Injectable({
  providedIn: 'root'
})
export class ScreenUtilsService {

  
  recordScreenHeight: number;
  recordScreenWidth: number;
  customScreenTableHeight:number;
  customScreenResize:number;
  limit:number;

  constructor() { 
    this.getScreenSize();
  }

  //record screen
  @HostListener('window:resize',['event'])
  getScreenSize(event?){
      this.recordScreenHeight = window.innerHeight;//record screen height
      this.recordScreenWidth = window.innerWidth;//record screen width
  }

  //get table row function
       /* recordScreenHeight --> the default screen height
        * spaceDeduction --> space out size the table (top and buttom)
        * rowDataHeight --> each row height in table 
        * limit --> setting the limit to loading the data in table
        */
  getTableRow(spaceDeduction:number, rowDataHeight:number){
    this.customScreenTableHeight = (this.recordScreenHeight - spaceDeduction);
    this.limit = this.customScreenTableHeight/rowDataHeight;
    return this.limit;
  }
  //set min-height for screen
        /* recordScreenHeight --> the default screen height
        *  paddingTopDeduction --> space header or section header
        */
  minHeight(paddingTopDeduction:number){
    this.customScreenResize = this.recordScreenHeight - paddingTopDeduction;
    return this.customScreenResize;
  }

  maxHeight(reduceHeihgt:number){
    this.customScreenResize = this.recordScreenHeight - reduceHeihgt;
    return this.customScreenResize;
  }
}
